import { RefObject, CSSProperties } from 'react';

/**
 * Props for the Circle component.
 */
interface IFirstGoalProps {
  /**
   * Reference to the HTML image element.
   */
  ref?: RefObject<HTMLImageElement> | null;

  /**
   * Additional CSS class names for styling.
   */
  className?: string;

  /**
   * Inline styles for the component.
   */
  style?: CSSProperties;
}

/**
 * -----------------------------------------------------------------------------
 * Renders a circle SVG component.
 */
export function FirstGoalPost({ ref, className, style }: IFirstGoalProps) {
  return (
    <div ref={ref} className={className} style={style}>
      <svg
        fill="#FFFFFF"
        viewBox="0 0 93 98"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group 363">
          <circle
            cx="46.9065"
            cy="54.1928"
            fill="#EBEBEB"
            fillOpacity="0.8"
            id="Ellipse 1"
            r="40.3523"
            stroke="white"
            strokeWidth="4"
          />
          <path
            d="M4.48899 72.5474C4.48899 74.3434 4.48899 75.7657 4.48899 77.188C4.48899 78.6103 4.08154 79.6484 2.74805 79.7938C2.47314 79.8297 2.19455 79.7988 1.93125 79.7032C1.66794 79.6076 1.42613 79.4494 1.22225 79.2396C1.01837 79.0297 0.857235 78.7731 0.749799 78.4871C0.642364 78.2012 0.591136 77.8926 0.599653 77.5825C0.340364 74.0631 -0.32638 70.4295 0.192197 67.0347C1.22009 60.3697 1.39604 53.6216 2.3406 46.9878C4.55381 31.4153 10.7582 18.2721 21.7872 8.26421C26.0294 4.41052 31.0132 1.71638 36.3444 0.394917C36.8323 0.255175 37.327 0.147711 37.8261 0.0730848C38.3122 -0.0720399 38.8296 0.000694566 39.2686 0.275875C39.7077 0.551056 40.0339 1.00706 40.1782 1.54728C40.5486 3.01109 39.8263 3.87277 38.6503 4.28804C37.4742 4.7033 36.1685 5.01475 34.9462 5.47154C29.4151 7.63187 24.444 11.2866 20.4723 16.1127C15.1289 22.2403 11.2276 29.7605 9.11915 37.9972C9.48956 37.4885 9.88776 36.9591 10.2304 36.4711C10.573 35.9832 10.962 35.1631 11.3324 34.509C16.7981 24.4829 25.1707 16.8667 35.048 12.9359C53.7168 5.36773 74.0987 13.9741 84.0628 26.5255C93.212 38.018 95.3141 51.0366 90.1098 65.3737C87.5394 72.6347 83.2644 78.9806 77.738 83.7388C63.4123 96.0099 47.392 100.349 29.7418 95.5323C24.5562 94.2272 19.6992 91.6299 15.5312 87.933C11.3632 84.2361 7.99106 79.5347 5.66504 74.1773C5.47984 73.7828 5.28539 73.3987 5.08167 73.0249C5.04463 72.9419 4.95201 72.9107 4.48899 72.5474ZM43.0119 92.5528C52.2651 92.4571 61.3338 89.6398 69.3111 84.3825C76.8583 79.4512 82.683 72.672 85.9797 63.5361C90.4987 51.1819 88.7578 39.9282 80.8587 29.9203C77.1274 25.3437 72.556 21.7275 67.4591 19.3207C49.3552 10.3405 29.3622 15.739 17.7034 32.8168C12.9367 39.8996 9.25333 47.8215 6.80407 56.2586C6.36582 57.7176 6.24204 59.2723 6.4429 60.7953C8.23014 72.9107 13.7956 82.0881 23.6301 87.7876C29.5659 91.2343 35.974 92.4698 43.0119 92.5528Z"
            fill="white"
            id="Vector"
          />
        </g>
      </svg>
    </div>
  );
}
